import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const BuildYourBandSkeletan = () => {
  const skeletonArr = new Array(5).fill("6");
  return (
    <div style={{ height: "100vh" }}>
      <Row>
        <Col md={6}>
          <Skeleton width="100%" height="60%" />
          <div className="d-flex">
            <Skeleton className="me-3" width={200} height={40} />
            <Skeleton width={300} height={40} />
          </div>
        </Col>
        <Col md={6}>
          {skeletonArr?.map((s) => (
            <div className="mb-3" id={s}>
              <Skeleton className="mb-2" width={300} height={30} />
              <ul className="d-flex mb-4">
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
                <li className="me-2">
                  <Skeleton width={50} height={50} />
                </li>
              </ul>
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default BuildYourBandSkeletan;
